const getApiBaseUrl = () => {
  if (window.location.hostname.includes('localhost')) {
    return process.env.API_BASE_URL || 'http://localhost:8000';
  }
  return `${window.location.protocol}//${window.location.hostname}`;
};

export const API_BASE_URL = getApiBaseUrl();
